export default __webpack_public_path__ + "images/330b7d99bfbae8039a5456998d97914f.svg";